<template>
  <div class="app-section">
    <div class="app-section-container" v-if="title">
      <h2 class="app-section-title" :style="titleStyle">{{title}}</h2>
    </div>
    <div class="app-section-content" :style="contentStyle">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
.app-section {
  margin: 0;

  &-container {
    color: #52575c;
    display: flex;
    justify-content: center;
    align-content: center;
    height: 40px;
    position: relative;

    &:before {
      border-top: 1px solid #52575c;
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 48%;
    }
  }

  &-title {
    background-color: #f2f2f2;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0 1rem;
    text-align: center;
    margin-top: 1em;
    z-index: 1;
  }

  &-content {
    padding: 0.6rem 1rem;
    flex: 1;
    @media screen and (max-width: 340px) {
      padding: 0.4rem 0 !important;
    }
  }
}
</style>

<script>
export default {
  props: ['title', 'bgColor', 'padding'],
  computed: {
    titleStyle() {
      return {
        backgroundColor: this.bgColor || '#f2f2f2'
      }
    },
    contentStyle() {
      return {
        padding: this.padding || '0.6rem 1rem'
      }
    }
  }
}
</script>